import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useAppDispatch } from '../Context'
import Sidebar from './Sidebar'
import Map from './Map'
import LocationSearch from './LocationSearch'
import { geolocate } from '@common/util'
import ajax from '@common/ajax'

function App({ data }) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch({ type: 'setLocations', payload: data.locations })
    dispatch({ type: 'setEndpoint', payload: data.endpoint })

    if (data.userCoords) {
      dispatch({ type: 'setUserCoords', payload: data.userCoords })
    }

    if (data.userZip) {
      dispatch({ type: 'setUserZip', payload: data.userZip })
    }

    document.getElementById('offices-app').classList.add('is-init')
  }, [])

  useEffect(() => {
    const attemptGeolocation = () => {
      geolocate(
        async (pos) => {
          dispatch({ type: 'setIsLoading', payload: true })

          const res = await ajax
            .get(`${data.endpoint}locationsbygeocode?lat=${pos.coords.latitude}&lng=${pos.coords.longitude}`)
            .json()

          if (res.success) {
            dispatch({ type: 'setSelectedLocation', payload: null })
            dispatch({ type: 'setLocations', payload: res.locations })
            dispatch({ type: 'setUserCoords', payload: res.position })
            dispatch({ type: 'setUserZip', payload: res.zip })

            Cookies.set(
              'userlocation',
              JSON.stringify({
                lat: res.position.lat,
                lng: res.position.lng,
                zip: res.zip,
              }),
              { expires: 1 }
            )
          }

          dispatch({ type: 'setIsLoading', payload: false })
        },
        () => {
          dispatch({ type: 'setIsLoading', payload: false })
        }
      )
    }

    // Only attempt geolcation if the user doesn't already have a location cookie
    if (!Cookies.get('userlocation')) {
      attemptGeolocation()
    }
  }, [data.endpoint])

  return (
    <article className="locations-wrapper">
      <Sidebar pageTitle={data.pageTitle} pageSubtitle={data.pageSubtitle} />
      <Map apiKey={data.apiKey} initialCenter={data.userCoords} />
      <LocationSearch />
    </article>
  )
}

export default App
